module.exports = __webpack_public_path__ + "30fccdb410f94076316d45f6be2668c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/mastercard_2021_chart.png
// module id = 1692
// module chunks = 0